/*
  Import this file to automatically extend ExtendedPropTypes with the
  standalone `prop-types` library's validators.
*/

"use strict";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require(".");

var _2 = _interopRequireDefault(_);

Object.keys(_propTypes2["default"]).forEach(function (name) {
  _2["default"][name] = _propTypes2["default"][name];
});